import { noSelectionKey } from '../../../../utilities/filterAndSortingsUtil';

export const getFieldTemplateCommandBarItems = (
  translator,
  OnDeleteButtonPress,
  onEditButtonPress,
  selectedKey,
  fieldTemplateBeingUpdated,
) => {
  return [
    {
      key: 'editFieldTemplate',
      name: translator('pages.adminFieldTemplates.editButton'),
      iconProps: {
        iconName: 'Edit',
      },
      onClick: onEditButtonPress,
      disabled:
        !selectedKey ||
        selectedKey === noSelectionKey ||
        fieldTemplateBeingUpdated,
      buttonStyles,
    },
    {
      key: 'deleteFieldTemplate',
      name: translator('pages.adminFieldTemplates.deleteButton'),
      iconProps: {
        iconName: 'Delete',
      },
      onClick: OnDeleteButtonPress,
      disabled:
        !selectedKey ||
        selectedKey === noSelectionKey ||
        fieldTemplateBeingUpdated,
      buttonStyles,
    },
  ];
};
const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
